var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 40.1501V7.55005L40.35 23.85L14.75 40.1501ZM19.45 31.55L31.6 23.85L19.45 16.15V31.55Z",
    fill: "black"
  })));
};

export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0Ljc1IDQwLjE1MDFWNy41NTAwNUw0MC4zNSAyMy44NUwxNC43NSA0MC4xNTAxWk0xOS40NSAzMS41NUwzMS42IDIzLjg1TDE5LjQ1IDE2LjE1VjMxLjU1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";